import FraudCheckbox from "./FraudCheckbox";

export default FraudCheckbox;